module.exports = __webpack_public_path__ + "6867a7ad1d5bc2fc04748a958b53cfc9.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room10/audio1/10_conversation.ogg
// module id = 767
// module chunks = 0